var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartV2 = function SvgHeartV2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.25 7.125A4.875 4.875 0 0 1 9.5 3.607a4.875 4.875 0 0 1 8.25 3.518c0 2.35-1.377 4.5-2.983 6.121-1.613 1.63-3.585 2.858-5.03 3.338a.75.75 0 0 1-.474 0c-1.445-.48-3.417-1.709-5.03-3.338-1.606-1.622-2.983-3.77-2.983-6.121M6.125 3.75A3.375 3.375 0 0 0 2.75 7.125c0 1.774 1.06 3.563 2.549 5.066 1.384 1.398 3.029 2.436 4.201 2.885 1.172-.45 2.817-1.487 4.201-2.885 1.489-1.503 2.549-3.292 2.549-5.066a3.375 3.375 0 0 0-6.137-1.94.75.75 0 0 1-1.226 0A3.37 3.37 0 0 0 6.125 3.75",
    clipRule: "evenodd"
  })));
};
export default SvgHeartV2;